import { bl_fi_item_with_category_file_import_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class FinancialItemCategoryFileImportContainer extends BaseContainerModel {
    bl_fi_item_with_category_file_import: bl_fi_item_with_category_file_import_RowClass = new bl_fi_item_with_category_file_import_RowClass();
}
